import request from '../utils/request'


export function index(params) {
  return request({
    url: '/departments',
    method: 'get',
      params
  })
}


export function show(id) {
    return request({
      url: `/departments/${id}`,
      method: 'get'
    })
  }

  export function store(data) {
    return request({
      url: '/departments',
      method: 'post',
      data
    })
  }

  export function update(data) {
    return request({
      url: `/departments/${data.id}`,
      method: 'put',
      data
    })
  }

  export function destroy(id) {
    return request({
      url: `/departments/${id}`,
      method: 'delete',
    })
  }
